// Copyright © 2021 Move Closer
import { AdBannerSize } from './AdBanner.contracts';
/**
 * Registry that binds the `AdBannerSize` with the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const adBannerSizeClassRegistry = {
    [AdBannerSize.MainContent]: '--size-main-content',
    [AdBannerSize.MainIndex]: '--size-main-index',
    [AdBannerSize.InText]: '--size-in-text',
    [AdBannerSize.Medium]: '--size-medium',
    [AdBannerSize.HorizontalMobile]: '--size-horizontal-mobile',
    [AdBannerSize.Fullscreen]: '--size-fullscreen',
    [AdBannerSize.Sticky]: '--size-sticky',
    [AdBannerSize.StickyFixed]: '--size-sticky-fixed',
    [AdBannerSize.StickyTeaser]: '--size-sticky-teaser'
};
/**
 * Registry that binds the `AdBannerSize` with the applicable creatives' dimensions.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const adBannerSizeCreativesDimensionsRegistry = {
    [AdBannerSize.MainContent]: [[300, 600]],
    [AdBannerSize.MainIndex]: [[300, 600], [300, 250], [300, 300], [970, 250], [950, 200]],
    [AdBannerSize.InText]: [[300, 250], [750, 200]],
    [AdBannerSize.Medium]: [[300, 250], [300, 300]],
    [AdBannerSize.HorizontalMobile]: [[300, 50]],
    [AdBannerSize.Fullscreen]: [[300, 600], [580, 400]],
    [AdBannerSize.Sticky]: [],
    [AdBannerSize.StickyFixed]: [],
    [AdBannerSize.StickyTeaser]: []
};
/**
 * Values of tolerance for padding and with
 *
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const tolerances = {
    padding: 0.005,
    width: 5
};
